export const SELECTED_FILTERS_NO_DATA_MESSAGE =
  'No data available for the selected filters. Please edit the filters.'
